import React from 'react';
import { Form } from 'react-bootstrap';

interface ConnectionSAPIBPProps {
  connectionData: any;
  handleParameterChange: (key: string, value: any) => void;
}

const ConnectionSAPIBP: React.FC<ConnectionSAPIBPProps> = ({ connectionData, handleParameterChange }) => {
  const params = connectionData?.connection_parameters ?? {};

  const handlePortChange = (value: string) => {
    // allow empty input; otherwise parse as integer
    if (value === '') {
      handleParameterChange('port', '');
    } else {
      const n = Number(value);
      handleParameterChange('port', Number.isFinite(n) ? n : '');
    }
  };

  return (
    <>
      <Form.Group controlId="sapibp-url" className="mb-2">
        <Form.Label>URL</Form.Label>
        <Form.Control
          type="text"
          placeholder="https://example.company.com"
          value={params.url || ''}
          onChange={(e) => handleParameterChange('url', e.target.value)}
        />
      </Form.Group>

      <Form.Group controlId="sapibp-port" className="mb-2">
        <Form.Label>Port</Form.Label>
        <Form.Control
          type="number"
          inputMode="numeric"
          placeholder="443"
          value={params.port ?? ''} // keep number if present, empty string otherwise
          onChange={(e) => handlePortChange(e.target.value)}
          min={1}
          max={65535}
        />
      </Form.Group>

      <Form.Group controlId="sapibp-username" className="mb-2">
        <Form.Label>Username</Form.Label>
        <Form.Control type="text" autoComplete="username" value={params.username || ''} onChange={(e) => handleParameterChange('username', e.target.value)} />
      </Form.Group>

      <Form.Group controlId="sapibp-password" className="mb-2">
        <Form.Label>Password</Form.Label>
        <Form.Control
          type="password"
          autoComplete="current-password"
          value={params.password || ''}
          onChange={(e) => handleParameterChange('password', e.target.value)}
        />
      </Form.Group>
    </>
  );
};

export default ConnectionSAPIBP;
